import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSparkleAi = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1_21)",
		children: /* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_1_21)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M6.6867 2.83747C6.60714 2.35443 6.18956 2 5.7 2C5.21044 2 4.79286 2.35443 4.7133 2.83748C4.6133 3.44455 4.39371 3.8516 4.1155 4.1271C3.83631 4.40358 3.42903 4.61586 2.83748 4.7133C2.35443 4.79286 2 5.21044 2 5.7C2 6.18956 2.35443 6.60714 2.83747 6.6867C3.44455 6.7867 3.8516 7.00629 4.1271 7.2845C4.40358 7.56369 4.61586 7.97097 4.7133 8.56252C4.79286 9.04557 5.21044 9.4 5.7 9.4C6.18956 9.4 6.60714 9.04557 6.6867 8.56253C6.78414 7.97097 6.99642 7.56369 7.2729 7.2845C7.5484 7.00629 7.95545 6.7867 8.56253 6.6867C9.04557 6.60714 9.4 6.18956 9.4 5.7C9.4 5.21044 9.04557 4.79286 8.56252 4.7133C7.95545 4.6133 7.5484 4.39371 7.2729 4.1155C6.99642 3.83631 6.78414 3.42902 6.6867 2.83747Z",
				stroke: "#FFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				shapeRendering: "crispEdges"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M13.892 2.87392C13.8285 2.3744 13.4035 2 12.9 2C12.3965 2 11.9715 2.3744 11.908 2.87392C11.5859 5.40808 10.9021 7.2346 9.78969 8.51626C8.69227 9.78066 7.07621 10.6306 4.64499 11.0121C4.1585 11.0884 3.8 11.5076 3.8 12C3.8 12.4924 4.1585 12.9116 4.64499 12.9879C7.07621 13.3694 8.69227 14.2193 9.78969 15.4837C10.9021 16.7654 11.5859 18.5919 11.908 21.1261C11.9715 21.6256 12.3965 22 12.9 22C13.4035 22 13.8285 21.6256 13.892 21.1261C14.2141 18.5919 14.8979 16.7654 16.0103 15.4837C17.1077 14.2193 18.7238 13.3694 21.155 12.9879C21.6415 12.9116 22 12.4924 22 12C22 11.5076 21.6415 11.0884 21.155 11.0121C18.5917 10.6099 16.9738 9.7062 15.9071 8.42658C14.8209 7.12345 14.2012 5.30628 13.892 2.87392Z",
				stroke: "#FFF",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				shapeRendering: "crispEdges"
			})]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_1_21",
		x: -3,
		y: 1,
		width: 30,
		height: 30,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_1_21"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_1_21",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1_21",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	})] })]
});
const ForwardRef = forwardRef(SvgSparkleAi);
export default ForwardRef;
